import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#004FD6"
      d="M29.25 10.016A3 3 0 0 0 27 9h-7V7a5.003 5.003 0 0 0-5-5c-.187 0-.367.05-.527.148a1 1 0 0 0-.368.403L9.383 12H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h21.5c.73 0 1.438-.266 1.984-.75.551-.484.903-1.148.993-1.875l1.5-12a3.014 3.014 0 0 0-.727-2.36M4 14h5v11H4Zm0 0"
    />
  </svg>
);
const SvgIconThumbsUpFilled = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconThumbsUpFilled);
export default Memo;
